import React from 'react';
import { useStudioTemplateChooser, type StudioImportableReport } from 'src/components/star-grid/hooks/useStudioTemplateChooser';
import { StudioTemplateChoices } from 'src/components/star-grid/components/StudioTemplateChoices';
import type { StudioTemplateOption } from 'src/components/star-grid/reportStudio.types';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import styles from 'src/components/star-grid/components/styles/StudioHeader.module.scss';
interface Props {
  readonly templates: readonly StudioTemplateOption[];
  readonly selectedId: string;
  readonly onChange: (id: string) => void;
  readonly text: StarGridText;
  /** Saved reports offered as a starting point; create only. */
  readonly importable?: readonly StudioImportableReport[];
}
export const StudioTemplateChooser: React.FC<Props> = ({ templates, selectedId, onChange, text, importable }) => {
  const selection = useStudioTemplateChooser(templates, selectedId, onChange, text, importable);
  return (
    <section className={styles.templateChooser} aria-label={text('studioTemplateLabel')}>
      <div className={styles.templateHeading}>
        <span className={styles.fieldLabel}>{text('studioTemplateLabel')}</span>
      </div>
      <StudioTemplateChoices selection={selection} text={text} />
    </section>
  );
};
export default StudioTemplateChooser;
